var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_row",on:{"click":function($event){return _vm.click()}}},[_c('div',[_vm._v(_vm._s(_vm.item.title))]),_c('div',[_vm._v(_vm._s(_vm.item.area))]),_c('div',[_vm._v(_vm._s(_vm._f("thousands")(_vm.item.price))+" руб.")]),_c('div',[_vm._v(_vm._s(_vm.item.category))]),_c('div',[_vm._v(_vm._s(_vm.item.comment))])])
}
var staticRenderFns = []

export { render, staticRenderFns }